import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// DevExtreme has been removed from this application.
//
// v24.1 shipped a licence check that showed a red "For evaluation purposes only"
// banner on every screen when no key was registered, and no key has ever existed
// in this repo. Rather than register a licence the organisation would have had
// to buy, all 239 grids were migrated to <app-data-grid> (ng-zorro nz-table) and
// the package was removed - which removes the banner, the licence obligation and
// ~4 MB of bundle at once. See docs/DEVEXTREME_GRID_MIGRATION.md.

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.log(err));
